var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.89543 0 0 0.895432 0 2V36C0 37.1046 0.895433 38 2 38H15.5L13.5 42H12C11.4477 42 11 42.4477 11 43C11 43.5523 11.4477 44 12 44H32C32.5523 44 33 43.5523 33 43C33 42.4477 32.5523 42 32 42H30.5L28.5 38H42C43.1046 38 44 37.1046 44 36V2C44 0.895429 43.1046 0 42 0H2ZM28.2639 42L26.2639 38H17.7361L15.7361 42H28.2639ZM2 2L42 2V29H2V2ZM2 31V36H42V31H2ZM26 33.5C26 32.9477 26.4477 32.5 27 32.5H29C29.5523 32.5 30 32.9477 30 33.5C30 34.0523 29.5523 34.5 29 34.5H27C26.4477 34.5 26 34.0523 26 33.5ZM37 32.5C36.4477 32.5 36 32.9477 36 33.5C36 34.0523 36.4477 34.5 37 34.5H39C39.5523 34.5 40 34.0523 40 33.5C40 32.9477 39.5523 32.5 39 32.5H37ZM31 33.5C31 32.9477 31.4477 32.5 32 32.5H34C34.5523 32.5 35 32.9477 35 33.5C35 34.0523 34.5523 34.5 34 34.5H32C31.4477 34.5 31 34.0523 31 33.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26V20H5V26H8ZM8 26H11M8 26V16H11V26M11 26H14M11 26V19H14V26M14 26H17M14 26V16H17V26M17 26H20V13H17V26Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.25C15.5858 4.25 15.25 4.58579 15.25 5C15.25 5.41421 15.5858 5.75 16 5.75H18.9679L13.4894 10.0545L9.95 7.4C9.62388 7.15541 9.16212 7.21609 8.91026 7.53663L3.41026 14.5366C3.15435 14.8623 3.21093 15.3338 3.53664 15.5897C3.86234 15.8456 4.33383 15.7891 4.58974 15.4634L9.63667 9.04L13.05 11.6C13.3217 11.8038 13.6963 11.7995 13.9634 11.5897L20.25 6.65024V9.5C20.25 9.91421 20.5858 10.25 21 10.25C21.4142 10.25 21.75 9.91421 21.75 9.5V5C21.75 4.58579 21.4142 4.25 21 4.25H16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8C27.5817 8 24 11.5817 24 16C24 20.4183 27.5817 24 32 24C36.4183 24 40 20.4183 40 16C40 11.5817 36.4183 8 32 8ZM32 8V16.4783L37.5 21.5M32 17L39.5 12.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4928a16226ce1c318d0d53d94f0f885b.svg";
export { ForwardRef as ReactComponent };